const PurchaseType = {
  SET_INDICATOR_REQUESTS_TODOLIST: 'SET_INDICATOR_REQUESTS_TODOLIST',
  SET_INDICATOR_TODO_LIST_COUNT: 'SET_INDICATOR_TODO_LIST_COUNT',
  SET_PROGRESS_SELECTED_IDS_ARRAY: 'SET_PROGRESS_SELECTED_IDS_ARRAY',
  SET_FILTER_SORT_DATA: 'INDICATOR_TODO_SET_FILTER_SORT_DATA',
  CATEGORY: 'CATEGORY',
  SET_TODO_LIST_COUNT: 'SET_TODO_LIST_COUNT',
};

export default PurchaseType;
